/* import __COLOCATED_TEMPLATE__ from './business-address.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();